<script setup lang="ts"></script>

<template>
  <PageContainerAlignment as="footer" class="flex flex-col">
    <FooterContent />
    <FooterNotices />
  </PageContainerAlignment>
</template>
